import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Productlifecycle(props) {
    return (
        <div>
            <Container className="h-100 tekrevol_dark_bg p-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Full-Cycle">
                            <h2>Full-Cycle DevOps Consulting Services</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <p>From consulting to developing traditional and cloud-based software to battle-testing applications, TekRevol takes the full responsibility of making this dev and operational collaboration yield the best results. While business goals and objectives do look different for different businesses, as advocates of DevOps strategies, the end result is always the same – improving the path to technical development.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Productlifecycle;